import { useQuoteCountdown } from "@/shared/hooks/useQuoteCountdown";

export interface BatchExpiry {
  isExpired: boolean;
  /** `HH:MM:SS` left, or `00:00:00` once expired. */
  formatted: string;
  /** Under an hour left — the banner switches to the warning tone. */
  isClosing: boolean;
}

const pad = (value: number) => value.toString().padStart(2, "0");

/**
 * Time left before a reviewed batch expires (`expires_at`, 24 h after upload). `onExpire` fires once, when
 * the clock reaches zero; the caller re-reads the batch then and trusts the server's EXPIRED, never the
 * clock.
 */
export function useBatchExpiry(expiresAt: string | null, onExpire?: () => void): BatchExpiry {
  const { isExpired, timeRemaining } = useQuoteCountdown(expiresAt, onExpire);
  const totalSeconds = Math.floor(timeRemaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return {
    isExpired,
    formatted: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`,
    isClosing: !isExpired && totalSeconds < 3600,
  };
}
